import { InformationCircleIcon } from '@heroicons/react/solid'
import RenderIf from '../RenderIf'


interface InformationAlertActionInterface {
  message: any
  detailsMessage?: string
  detailsLink?: string
}

export const InformationAlertAction = ({message, detailsMessage, detailsLink} : InformationAlertActionInterface) => {
    return (
    <div className="rounded-md bg-blue-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon className="h-5 w-5 text-blue-400 mt-0.5" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-md text-blue-700">{message}</p>
          <RenderIf condition={detailsMessage} >
          <p className=" md:ml-6">
            <a className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600" href={detailsLink} target="_blank" rel="noreferrer">
              {detailsMessage} <span aria-hidden="true">&rarr;</span>
            </a>
          </p>
          </RenderIf>
        </div>
      </div>
    </div>
  )
}